/**
 * A project template applied to a project: the user's instances per template
 * (Settings names the projects a template is set up in). Errors render where
 * they are used, so every request is silent.
 */
import { apiRequest } from "./client";

interface ApiResponse<T> {
  status: "success";
  data: T;
}

const BASE = "/api/v1/plugins/project-instances";

/** One scheduled job; `schedule_text` is the server's English wording. */
export interface PluginProjectJobSchedule {
  job_key: string;
  title: string;
  schedule_text: string;
  is_active: boolean;
  next_run_at: string | null;
}

export interface PluginProjectInstance {
  id: string;
  state: "configured" | "blocked";
  blocked_reason: string;
  project_id: string;
  slug: string;
  version: string;
  digest: string;
  artifacts: {
    frames: Record<string, string>;
    tasks: Record<string, string>;
  };
  configuration: Record<string, string>;
  /** Set up with an older template version: it runs, template actions are off. */
  legacy: boolean;
  /** Every scheduled job's schedule is on, and there is at least one. */
  started: boolean;
  schedules: PluginProjectJobSchedule[];
}

export async function listPluginProjects(
  slug: string,
): Promise<PluginProjectInstance[]> {
  const response = await apiRequest<ApiResponse<PluginProjectInstance[]>>(
    `${BASE}/?slug=${encodeURIComponent(slug)}`,
    { silent: true },
  );
  return response.data;
}
